/* lua.js generated code 0.3.0 */
var PaymentGuideManager = require("activity/IosPaymentGuide/PaymentGuideManager")
require("clover/panel/component/common/UIButton")
require("clover/ui/UIUtils")
require("clover/ui/HeadImageLoader")
require("clover/panel/component/common/UIGroupButton")
require("clover/panel/component/common/NumLabelMultiBg")
require("clover/panel/component/common/SpriteLabel")
require("clover/utils/GameSpeedManager")

require("clover/panel/component/levelpanel/PlayerHeadNode")

LevelRankType = table([1, "kFriend", 1], [1, "kGlobal", 2])
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
const MedalRankList = require("./component/levelpanel/MedalRankList")
var [PreProps, PrePropsEvent] = unpack(require("clover/panel/component/levelpanel/PreProps"))
var StartPanel = xClass("StartPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/start_start_main.csb")
})
var StartPanelEvent = table(
    [1, "StartClick", "STARTPANELEVENT.STARTCLICK"],
    [1, "PrePropSelect", "STARTPANELEVENT.PREPROPSELECT"],
    [1, "PrePropCancel", "STARTPANELEVENT.PREPROPCANCEL"],
    [1, "Close", "STARTPANELEVENT.CLOSE"],
    [1, "StartAnim", "STARTPANELEVENT.STARTANIM"],
    [1, "FinishAnim", "STARTPANELEVENT.FINISHANIM"],
    [1, "UsePropAnimFinish", "STARTPANELEVENT.USEPROPANIMFINISH"],
    [1, "PropTouchHijack", "STARTPANELEVENT.PROPTOUCHHIJACK"], // 自定义组件托管了关前道具的点击行为
    [1, "AdStartClick", "STARTPANELEVENT.ADSTARTCLICK"],
    [1, "BubbleClick", "STARTPANELEVENT.BUBBLECLICK"],
    [1, "PlayStrategy", "STARTPANELEVENT.PLAYSTRATEGY"],
)
StartPanel.RES = table(
    ""
)
StartPanel.show = function (levelId, initPropConfig, scoreConfig, levelInfo, onSuccess, onFail, onCancel, useEnergyPropId, useComplementStarPropId, isReplay) {
    function success() {
        //  检查是否获取到后端传来的配置
        if (initPropConfig.length < 2) {
            if (onFail) {
                onFail()
            }
            Toast.make(getText("未能获取到关卡道具信息\n请稍后再试"), null, () => {})
            //  未获取到关前道具配置，重新尝试获取
            ItemDataManager.loadPrePropData()
            return
        }
        try {
            let panel = StartPanel.create(levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId, useComplementStarPropId, isReplay)
            if (onSuccess) {
                onSuccess(panel)
            }else {
                panel.popup(true)
            }
            //冠军赛打点
            DCAssist.dc4ChampionStartLevelPanelShow(levelId) 
        } catch (error) {
            if (onFail) {
                onFail()
            }
            cc.error("error",error)
            window.logCenter && logCenter.error(new Error(JSON.stringify(error)), 'OpenStartPanelError');
        }
    }

    StartPanel.scoreConfig = scoreConfig;
    StartPanel.curLevelId = levelId;
    StartPanel.tryAddActRes(levelId)
    if (TTUtil.isOpenSmallPay()){
        StartPanel.RES.push("packed/ttGameRevivePanel.pack")
    }
    preloadWithLoading(StartPanel.RES, success, onFail, onCancel)
}
// 尝试添加活动资源
StartPanel.tryAddActRes = function(levelId){
    StartPanel.RES = table(
        "packed/StartPanelNewRes.pack",
        "spine/nuclear_bird/supermagicbird_bird.atlas",
        "spine/nuclear_bird/supermagicbird_bird.skel",
    )
    if(UserManager.getInstance().supportMedal()) {
        let temp = "cocos/start_start_medal.csb";
        if(!table.indexOf(StartPanel.RES, temp)) {
            table.insert(StartPanel.RES, temp);
        }
        temp = "cocos/start_medal.plist";
        if(!table.indexOf(StartPanel.RES, temp)) {
            table.insert(StartPanel.RES, temp);
        }
    }
    // 根据逻辑判断将banner资源加入加载列表
    const type = StartPanel.getBottomType();
    const res = StartPanel.getBottomRes(type);

    let insertFrameRes = ()=>{
        let frame_res = DressManager.getInstance().getNeedFrameRes()
        for (let i = 0; i < frame_res.length; i++) {
            table.insert(StartPanel.RES, frame_res[i])
        }
    }
    let temp = "packed/NewRankBanner.pack";
    if(!table.indexOf(StartPanel.RES, temp)) {
        table.insert(StartPanel.RES, temp);
    }
    if (type && res) {
        if (!table.indexOf(StartPanel.RES, res)) {
           table.insert(StartPanel.RES, res);
           insertFrameRes()
        }
    } else {
        if(!LevelType.isMysteryIslandLevel(levelId)) {
            temp = "packed/MysteryIslandRank.pack";
            if(!table.indexOf(StartPanel.RES, temp)) {
                table.insert(StartPanel.RES, temp);
            }
            insertFrameRes()
        }
    }
    
    
    // if (levelId == UserManager.getInstance().user.topLevelId){
    //     let endTime = SeasideStarManager.getInstance().getDoubleCardBuffEnd()
    //     if ((endTime - Localhost.time()) > 0 && !table.indexOf(StartPanel.RES ,"packed/SeasideStarStart.pack")){
    //         table.insert(StartPanel.RES , "packed/SeasideStarStart.pack")
    //     }
    // }
    // if (PurpleAmyMagicManager.getInstance().isUseByLevel(levelId)){
    //     if (!table.indexOf(StartPanel.RES ,"packed/PurpleAmyMagicMain.pack")){
    //         table.insert(StartPanel.RES , "packed/PurpleAmyMagicMain.pack")
    //     }
    // }
    // if (QualifyGameManager.getInstance().isOpen() 
    // && (UserScore.getInstance().isNeedComplementStar(levelId)||levelId == UserManager.getInstance().user.topLevelId)){
    //     if (!table.indexOf(StartPanel.RES ,"packed/QualifyStart.pack")){
    //         table.insert(StartPanel.RES , "packed/QualifyStart.pack")
    //     }
    // }
    console.log("tryAddActRes.show ",StartPanel.RES )
}
StartPanel.prototype.ctor = function (levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId, useComplementStarPropId, isReplay) {
    var self = this
    PaymentGuideManager.getInstance().setInStartpanel(true)

    if (SnsProxy.getInstance().allowAd()) {
        //看广告开始关卡逻辑
        require("activity/Ads/AdStartPropManager").getInstance()
        self.adStartReward = AdStartPropManager.getInstance().getAdStartReward(levelId, initPropConfig)
        console.log("adstart self.adStartReward", self.adStartReward)
    }
    // 判断当前关卡补星状态（是否有历史分数）是否有补星道具
    // if (UserScore.getInstance().isNeedComplementStar(levelId)){
    //     self.useComplementStarPropId = true
    // }
    self.useComplementStar = useComplementStarPropId
    self.isReplay = isReplay

    self.init(levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId);
    self.fitScreen()
    // 关前道具广告逻辑
    if (SnsProxy.getInstance().allowAd()) {
        require.ensure([], () => {   
            let StartPanelAdMngr = require("./startPanelAd/StartPanelAdMngr");
            if(StartPanelAdMngr.getInstance().getAvailableProp(levelId, initPropConfig)) {
                self.adPrepropCmpt = require("./startPanelAd/StartPanelAdCmpt").create(self);
            }
        }, null, 'act')
    }
    HomeScenePopoutManager.getInstance().popoutStop();
}

StartPanel.prototype.init = function (levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId) {
    var self = this
    self.bind(self)
    self.levelId = levelId
    self.scoreConfig = clone(scoreConfig)
    self.initPropConfig = clone(initPropConfig)
    self.levelInfo = clone(levelInfo)
    self.preProps = table()
    BasePanel.prototype.init.call(self)
    var close = UIGroupButton.create(self.getChildByName("com_close"))
    ButtonPushBounceAnim.create(close)
    close.setLocalZOrder(30)
    // close.setPosition(cc.p(close.getPositionX() + 10, close.getPositionY() + 15))
    close.on(UIButtonEvent.Click, function () {
        let instance = GameSpeedManager.getInstance()
        if (instance.isReplayPanel === true) {
            instance.isReplayPanel = false
            if (instance.isEffectLevel()) {
                //  恢复到玩家设定的速度
                instance.updateGameSpeed()
            } else {
                //  恢复到当前模式自身速度
                instance.updateGameSpeed2Default()
            }
        }
        self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
    })

    // this.getChildByName("start_main_bg").height = 200

    this.initUI()
    self.useEnergyPropId = useEnergyPropId || 0;
    self.initButton()


    self.buildLevelInfo()
    self.buildStar()
    self.buildBuffProp()
    self.buildPreProps()
    self.buildNuclearBirdUI()
    // self.buildBattlePassHint()
    let hasUnlockProp = false
    for (var k = 1, v = self.initPropConfig[1]; v; k++, v = self.initPropConfig[k]) {
        if (!v.locked) {
            hasUnlockProp = true
            break
        }
    }

    // self.initButton()
    // self.initAdStartButton()
    // self.initComplementStarButton()
    // var close = UIGroupButton.create(self.getChildByName("btn_close"))
    // ButtonPushBounceAnim.create(close)
    // close.setLocalZOrder(30)
    // close.setPosition(cc.p(close.getPositionX() + 10, close.getPositionY() + 15))
    // close.on(UIButtonEvent.Click, function () {
    //     let instance = GameSpeedManager.getInstance()
    //     if (instance.isReplayPanel === true) {
    //         instance.isReplayPanel = false
    //         if (instance.isEffectLevel()) {
    //             //  恢复到玩家设定的速度
    //             instance.updateGameSpeed()
    //         } else {
    //             //  恢复到当前模式自身速度
    //             instance.updateGameSpeed2Default()
    //         }
    //     }
    //     self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
    // })
    // var hasUnlockProp = false
    // for (var k = 1, v = self.initPropConfig[1]; v; k++, v = self.initPropConfig[k]) {
    //     if (!v.locked) {
    //         hasUnlockProp = true
    //         break
    //     }
    // }
    // if (hasUnlockProp) {
    //     let btn = self.getChildByName("btn_prompt")
    //     var question = UIGroupButton.create(btn)
    //     question.setLocalZOrder(100)
    //     ButtonPushBounceAnim.create(question)
    //     question.on(UIButtonEvent.Click, function () {
    //         require("clover/panel/PrepropHelpPanel").create().popup(true)
    //     })
    // } else {
    //     self.getChildByName("btn_prompt").setVisible(false)
    // }
    // self.setScale(self.getReferenceScale())
    // var bg2 = self.getChildByName("panel_sandbeach")
    // //bg2.setCapInsets(cc.rect(312, 140, 3, 1))
    // var size = bg2.getContentSize()
    // var tSize = cc.size(610, -bg2.getPositionY() + size.height)
    // var vSize = cc.Director.getInstance().getVisibleSize()
    // self.setPosition(cc.p((vSize.width - tSize.width * self.getScale()) / 2, (vSize.height + tSize.height * self.getScale()) / 2 - 80))
    // var prepos = cc.p(bg2.getPosition())
    // bg2.setAnchorPoint(cc.p(0, 0))
    // bg2.setPosition(prepos.x - 4, prepos.y - size.height + 13)
    // self.recordData()
    // self.setContentSize(tSize)
    // self.setPositionY(self.getPositionY() + 43.85)
    self.waitingPanelAnim = true
    self.on(StartPanelEvent.FinishAnim, function() {
        self.waitingPanelAnim = false
        var winSize = cc.Director.getInstance().getWinSize();
        var dH = winSize.height - GamePlayConfig_Design_Height;
        var infoBanner = require("clover/scene/component/homescene/HomeSceneInfoBanner").create(null, true, false)
        infoBanner.updateView()
        infoBanner.setPosition(-self.x / self.scale,   -self.y * self.scale )
        infoBanner.banner_bg.setVisible(false);
        self.addChild(infoBanner, 9999)
        HomeSceneAnimation.setStarDrawInfoBanner(infoBanner);
        infoBanner.cash_btn.getChildByName("add_btn").setVisible(false);
        infoBanner.energy_btn.setVisible(false);
        infoBanner.coin_btn.getChildByName("add_btn").setVisible(false);
        if (UserManager.getInstance().isShowPrePropsGuide(levelId)){
            self.showPrePropsGuide()
        }
    })

    this.initActUI()
    self.initStrategy();
    self.initMedal();

    self._kMedalRankOpen = function (event) {
        let show = true;
        if (event.data && event.data.show == true) {
            show = false;
        }
        self.setVisible(show);
        if (self.actBanner) {
            self.actBanner.setVisible(show);
        }
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kMedalRankOpen,
        self._kMedalRankOpen,
    );
}
StartPanel.prototype.getAction = function (root, type, pos, contentSize, text) {
    let self = this
    let action = table(
        [1, "root", root],
        [1, "guideAction", table(
            [1, "type", type],
            [1, "flip", true],
            [1, "delay", 0],
            [1, "scale", 1],
            [1, "posMode", "win"],
            // [1, "p1", -470],
            // [1, "p2", -display.height/2 + 300],
            [1, "p1", 0],
            [1, "p2", -contentSize.height/2 - 180],
            [1, "bubblePos", 1],
            [1, "fontSize", 28],
            [1, "bubbleSize", cc.size(contentSize.width-50, 160)],
            [1, "fontColor", cc.c4b(177, 115, 68, 255)],
            [1, "textAlign", "center"],
            [1, "textMargin", cc.p(50, 0)],
            [1, "text", text],  
        )],
        [1, "maskAction", table(
            [1, "type", "mask"],
            [1, "fade", 0.01],
            [1, "touchDelay", 1.5],
            [1, "opacity", 200],
            [1, "hole", table([0, table(
                [1, "type", "square"],
                [1, "border", 2],
                [1, "posMode", "win"],
                [1, "p1", pos.x  ],
                [1, "p2", pos.y ],
                [1, "width", contentSize.width],
                [1, "height", contentSize.height]
            )])],
            [1, "touch", table([0, table(
                [1, "type", "square"],
                [1, "border", 2],
                [1, "posMode", "win"],
                [1, "p1", pos.x],
                [1, "p2",  pos.y ],
                [1, "width", contentSize.width],
                [1, "height", contentSize.height]
            )])],
            [1, "skipCb", function(){
                self.runningGuide && self.runningGuide.skip()
            }],
        )],
        [1, "skipText", true],
        
    )
    return action
}
// 关前引导
StartPanel.prototype.showPrePropsGuide= function () {
    let self = this
    // let pos = cc.p(300,800)
    let contentSize = self.selectNode.getContentSize()
    
    let pos = self.selectNode.getParent().convertToWorldSpace(self.selectNode.getPosition())
    contentSize.width = contentSize.width * self._scale
    contentSize.height = contentSize.height * self._scale

    pos = cc.p(pos.x- contentSize.width/2 ,pos.y - contentSize.height/2)
    let action1 = self.getAction(self, "singleBubbleNew", pos, contentSize, getText("进关前可以选择这些道具帮助过关"))

    let skipCb = ()=>{
        cc.log("引导结束")
    }
    let actionList = table()
    actionList.push(action1)


    require('activity/Common/ActivityGuideAni.js')
    ActivityGuideAni.asyncCreate (actionList, self, skipCb,99999)
}
StartPanel.prototype.initUI = function () {
    let self = this
    this.tittleNode = self.getChildByName("titileNode")
    this.purpleAmyNode = self.getChildByName("purple_amy")
    this.startNode = self.getChildByName("startNode")
    this.selectNode = self.getChildByName("select")
    this.selectNode.getChildByName("start_select").setVisible(false)
    let font_def = new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 26,
        fontWeight: 'bold',
        strokeEnabled: false,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOpacity: 0.5
    })
    let selectTitile = cc.LabelTTF.create("选择道具", font_def)
    this.selectNode.addChild(selectTitile)
    selectTitile.setPosition(this.selectNode.getChildByName("start_select").getPosition())
    selectTitile.setColor(cc.c3b(178, 102, 56))
    selectTitile.y -= 5
    


    this.bubbleNode = self.startNode.getChildByName("bubble_node")

    if (!PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId)){
        this.purpleAmyNode.setVisible(false)
    }


    var question = UIGroupButton.create(this.selectNode.getChildByName("com_detail"))
    // question.setLocalZOrder(100)
    ButtonPushBounceAnim.create(question)
    question.on(UIButtonEvent.Click, function () {
        require("clover/panel/PrepropHelpPanel").show();
    })

}

StartPanel.prototype.initActUI = function () {
    // this.initSeasideStarUI()
    this.initPrupleAmyMagicUI()
    // this.initQualifyUI()

}
StartPanel.prototype.initQualifyUI = function () {
    let self = this
    // 非满星关或者神秘岛不显示
    if(!LevelType.isMysteryIslandLevel(self.levelId) && !UserScore.getInstance().isNeedComplementStar(self.levelId)
    && self.levelId != UserManager.getInstance().user.topLevelId){
        return
    }
    try {
        // if (!this.testN){
        //     this.testN =true
            // QualifyGameManager.getInstance().info.buffEndTs = Localhost.time() + 2*60*1000 + 6*1000
        // }
        if (!QualifyGameManager.getInstance().isQualifyOpenWithLevelID(self.levelId,true)){
            self.cleanTimer()
            return
        }
        let state = QualifyGameManager.getInstance().getDoubleCardState()
        if (!this.qualifyNode){
            this.qualifyNode = QualifyGameManager.getInstance().createStartNode(()=>{
                self.initQualifyUI()
            },self.levelId)
            this.addChild(this.qualifyNode )
            this.qualifyNode.setPosition(150,-350)
            this.qualifyNode.setLocalZOrder(99999)
        }
        let lab_time = this.qualifyNode.lab_time
        this.qualifyNode.refreshUI()
        // lab_time.setVisible(state == 1)
        if (state == 1 && !self._schedulerId_qualify){
            self.remain_time_qualify  = QualifyGameManager.getInstance().getDoubleCardBuffEnd() - Localhost.time()
        }else{
            return
        }
        // self.remain_time_qualify = endTime - Localhost.time()

        lab_time.setString(QualifyGameManager.getInstance().parseTime(self.remain_time_qualify))
        self._schedulerId_qualify= cc.director.getScheduler().scheduleScriptFunc(function () { 
            if (!self || !self.nodeExist) return
            self.remain_time_qualify -= 1000
            if (self.remain_time_qualify > 0){
                lab_time.setString(QualifyGameManager.getInstance().parseTime((self.remain_time_qualify)))
            }else{
                // lab_time.setString("00:00:00")  
                self.cleanTimer()
                self.initQualifyUI()
            }
        }, 1, false);
    } catch (error) {
        LogToLogCenter(error)
    }

}
StartPanel.prototype.initPrupleAmyMagicUI = function () {
    let self = this
    if (!PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId)){
        return
    }
    try {
        
        PurpleAmyMagicManager.getInstance().createStartNode(self.levelId,self.purpleAmyNode)
        // this.addChild(purpleAmyMagicNode)
        // purpleAmyMagicNode.setPosition(500,150)
        // purpleAmyMagicNode.setScale(1.3)
    } catch (error) {
        LogToLogCenter(error)
    }

}
StartPanel.prototype.initSeasideStarUI = function () {
    let self = this
    let homeScene = require("clover/scene/HomeScene").getInstance()
    homeScene.updateStartBtnSeasideStar()
    if (self.levelId != UserManager.getInstance().user.topLevelId){
        return
    }
    let endTime = SeasideStarManager.getInstance().getDoubleCardBuffEnd()
    self.remain_time_seasideStar = endTime - Localhost.time()
    if (!SeasideStarManager.getInstance().isOpen() || self.remain_time_seasideStar <= 0) return

    let seasideStarNode = cc.CSLoader.createNode("cocos/seasidestar_seasidestar_start.csb")
    this.addChild(seasideStarNode)
    seasideStarNode.setPosition(150,-200)
    let doubleCard = SeasideStarManager.getInstance().createDoubleCardNode() 
    let level_start_bg = seasideStarNode.getChildByName("level_start_bg")
    level_start_bg.addChild(doubleCard)
    doubleCard.setPosition(level_start_bg.width/2,70)
    let timeLabel = seasideStarNode.getChildByName("time") 
    // let timeLabel = cc.LabelTTF.create("00:00:00", FONT_DEF.microsoftYahei_30_noStroke);
    // this.addChild(timeLabel)


    timeLabel.setString(parseTimeToHMS(self.remain_time_seasideStar))
    // self.remain_time_seasideStar = homeScene.remain_time_seasideStar
    self._schedulerId_seasideStar = cc.director.getScheduler().scheduleScriptFunc(function () { 
        if (!self || !self.nodeExist) return
        self.remain_time_seasideStar -= 1000
        if (self.remain_time_seasideStar > 0){
            timeLabel.setString(parseTimeToHMS(self.remain_time_seasideStar))
        }else{
            timeLabel.setString("00:00:00")  
            seasideStarNode.setVisible(false)
            self.cleanTimer()
        }
    }, 1, false);
}
StartPanel.prototype.isIndexRes = function (str) {
    return table.indexOf(StartPanel.RES ,str)
}
StartPanel.prototype.initActBanner = function () {
    let self = this;

    const type = StartPanel.getBottomType();
    const res = StartPanel.getBottomRes(type);
    if (!type || !res || !self.isIndexRes(res)) {//判断资源是否在加载列表中
        self.buildRank();
        return;
    }
    //1. 萌萌竞速开始2. 快艇大赛开始3. 钓鱼活动开始4. 萌萌竞速排名 5. 神秘岛排行榜6. 快艇大赛排名7. 钓鱼活动排名
    if(type == 1 || type == 4) {
        //
        let lMgr = LightningRushManager.getInstance()
        if (!lMgr.isOpen()) return
        if (lMgr.getState() == LightningRushManager.ACT_STATE.NOT_JOIN && lMgr.getRemainingTime() <= 0) return
        lMgr.rushLimitRobotGrowFetchHttp().then(function () {
            if (!self || self.isClosed) return;
            lMgr.infoHttp().then(function () {
                if (!self || self.isClosed) return;
                if (!lMgr.isOpen()) {
                    self.buildRank()
                    return;
                }
                if (lMgr.getState() == LightningRushManager.ACT_STATE.NOT_JOIN && lMgr.getRemainingTime() <= 0) return
                self.actBanner = lMgr.showBanner(self.levelId)
                self.actBanner.setScale(self.actBanner.scale / self._scale)
                self.dcPageShow("lightening_rush");
            }).catch((evt) => {

            })
        }).catch((evt) => {

        })
    }else if(type == 2 || type == 6) {
        if (SpeedboatMatchManager.getInstance().isOpen()) {
            self.actBanner = SpeedboatMatchManager.getInstance().addBanner(()=>{
                self.onCloseByBanner()
            });
            self.actBanner.popup();
            self.actBanner.setScale(self.actBanner.scale / self._scale)
            self.dcPageShow("speedboat_race");
        }
    }else if(type == 3 || type == 7) {
        if(FishingManager.getInstance().isOpen()) {
            self.actBanner = FishingManager.getInstance().showBanner(()=>{
                    self.onCloseByBanner()
            });
            self.actBanner.setScale(self.actBanner.scale / self._scale)
            self.dcPageShow("fishing_master");
        } 
    }else if(type == 8 || type == 9) {
        if(ChampionLogic.getInstance().isChampionOpen()) {
            self.actBanner = ChampionLogic.getInstance().addBanner(()=>{
                    self.onCloseByBanner()
                },self.levelId);
            self.actBanner.setScale(self.actBanner.scale / self._scale)
            self.actBanner.popup(self)
            self.dcPageShow("champion_race");

        } 
    }else if(type == 10 || type == 11) {
        if(DunkAceData.getInstance().inJoinTime() || DunkAceData.getInstance().inPlayTime()) { 
            DunkAceLogic.getInstance().infoHttp(0).then(function () {
                self.actBanner = DunkAceLogic.getInstance().showBanner(()=>{
                    self.onCloseByBanner()
                },self.levelId);
                self.actBanner.setScale(self.actBanner.scale / self._scale)
                self.actBanner.popup(self)
                self.dcPageShow("DunkAce");
            }).catch((evt) => {
    
            })
            

        } 
    }
}
/**
 * 初始化面板按钮
 */
StartPanel.prototype.initButton = function () {
    var self = this
    this.btn_start_big = this.startNode.getChildByName("btn_start_big")
    this.btn_start_small = this.startNode.getChildByName("btn_start_small")
    this.btn_start_ad = this.startNode.getChildByName("btn_start_ad")
    this.start_ad_bubble = this.startNode.getChildByName("start_ad_bubble")
    // self.button = UIGroupButton.create(self.getChildByName("btn_start"))
    // self.adStartReward = true
    if (!self.adStartReward){ //不能看广告开始
        this.btn_start_big.setVisible(true)
        this.btn_start_small.setVisible(false)
        this.btn_start_ad.setVisible(false)
        this.startBtn = UIGroupButton.create(this.btn_start_big)
    }else{
        this.btn_start_big.setVisible(false)
        this.btn_start_small.setVisible(true)
        this.btn_start_ad.setVisible(true)
        this.startBtn = UIGroupButton.create(this.btn_start_small)
    }
    this.refreshButton()
    self.startBtn.on(UIButtonEvent.Click, function () {
        GameSpeedManager.getInstance().isReplayPanel = false
        self.dispatchEvent(table([1, "name", StartPanelEvent.StartClick]))

        // // self.showEnergyAnim(10019)
        // self.playConsumeEnergyAnimation()
        // // self.showComplementStarAnim(GamePropsType.kComplementStar)

        // let node = cc.CSLoader.createNode("cocos/level_difficulty_bubble_lock.csb")
        // // let action = cc.CSLoader.createTimeline("cocos/level_difficulty_bubble_idle.csb")
        // // node.runAction(action)
        // // // node.getChildByName("bubble2").setVisible(false)
        // // // node.getChildByName("bubble1").setVisible(false)
        // // node.y = 200
        // // action.gotoFrameAndPlay(0)
        // // action.setTimeSpeed(0.1)
        // self.startNode.addChild(node)
        // // self.selectNode.setVisible(false)
    })
    // // body
    // cc.log("self.useEnergyPropId", self.useEnergyPropId)
    // self.getChildByName("btn_start2").setVisible(false)
    // self.getChildByName("bubble_select").setVisible(false)
    // self.getChildByName("bubble").setVisible(false)

    // if (self.useEnergyPropId){
    //     // 有精力瓶的按钮
    //     var startBtn = self.getChildByName("btn_start");
    //     var pos = startBtn.getPosition();
    //     startBtn.setVisible(false);
    //     var btnNode = cc.CSLoader.createNode("cocos/power_vigor_btn_green_start.csb");
    //     btnNode.y -= 5
    //     self.addChild(btnNode);
    //     btnNode.setPosition(pos);
    //     self.button = UIGroupButton.create(btnNode);

    //     if (self.useEnergyPropId == GamePropsType.kEnergy1){
    //         btnNode.getChildByName("icon2").setVisible(false);
    //         btnNode.getChildByName("num1_activity").setVisible(false);
    //         btnNode.getChildByName("num1").setVisible(false);
    //         btnNode.getChildByName("num5_activity").setVisible(false);
    //     }else{
    //         btnNode.getChildByName("icon1").setVisible(false);
    //         btnNode.getChildByName("num5_activity").setVisible(false);
    //         btnNode.getChildByName("num5").setVisible(false);
    //         btnNode.getChildByName("num1_activity").setVisible(false);
    //     }
    // }else{
    //     self.button = UIGroupButton.create(self.getChildByName("btn_start"))
    //     self.energy_icon = self.button.getChildByName("num_activity")
    //     self.energy_icon.setVisible(false)
    //     self.energy_num = self.button.getChildByName("num")
    // }

    
    // var text = self.button.getChildByName("label")
    // text.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    // text.setPositionX(text.getPositionX() + 18)
    // self.button.on(UIButtonEvent.Click, function () {
    //     GameSpeedManager.getInstance().isReplayPanel = false
    //     self.dispatchEvent(table([1, "name", StartPanelEvent.StartClick]))
    // })

    self.initAdStartButton()
    self.initComplementStarBubble()

}
StartPanel.prototype.refreshButton = function () {
    let self = this
    this.startBtn.getChildByName("num").setString("-1")
    self.energy_num =  this.startBtn.getChildByName("num")
    //console.log("[monthticket] StartPanel")
    var energyConsume = MetaManager.getInstance().global.user_energy_level_consume || 5
    // if (UserManager.getInstance().isHaveEquityMonthTicket()){
    //     energyConsume = 4
    // }
    if (self.useComplementStar ){
        self.energy_icon = this.startBtn.getChildByName("complement_star_bg")
        this.startBtn.getChildByName("energy_bg").setVisible(false)
        this.startBtn.getChildByName("energy_prop2").setVisible(false)
        this.startBtn.getChildByName("energy_prop1").setVisible(false)
    }else if (self.useEnergyPropId){
        if (self.useEnergyPropId == GamePropsType.kEnergy1){
            this.startBtn.getChildByName("num").setString("-"+energyConsume)
            self.energy_icon = this.startBtn.getChildByName("energy_prop1")
            this.startBtn.getChildByName("energy_bg").setVisible(false)
            this.startBtn.getChildByName("energy_prop2").setVisible(false)
            this.startBtn.getChildByName("complement_star_bg").setVisible(false)

        }else{
            self.energy_icon = this.startBtn.getChildByName("energy_prop2")
            this.startBtn.getChildByName("energy_bg").setVisible(false)
            this.startBtn.getChildByName("energy_prop1").setVisible(false)
            this.startBtn.getChildByName("complement_star_bg").setVisible(false)
        }
    }else{
        this.startBtn.getChildByName("num").setString("-"+energyConsume)
        self.energy_icon = this.startBtn.getChildByName("energy_bg")
        this.startBtn.getChildByName("energy_prop1").setVisible(false)
        this.startBtn.getChildByName("energy_prop2").setVisible(false)
        this.startBtn.getChildByName("complement_star_bg").setVisible(false)

    }
    self.energy_icon.setVisible(true)
}

StartPanel.prototype.initComplementStarBubble = function () {
    let self = this
    self.bubbleNode.setVisible(false)
    if (!self.useComplementStar){
        // self.bubbleNode.setVisible(false)
        return
    }
    self.bubbleNode.x =  this.startBtn.x + this.startBtn.width/2

    self.star_bubble_select = UIGroupButton.create(self.bubbleNode.getChildByName("bubble_select"))
    self.star_bubble = UIGroupButton.create(self.bubbleNode.getChildByName("bubble"))

    self.star_bubble_select.setVisible(true)
    self.star_bubble.setVisible(false)
    // self.star_bubble_select.getChildByName("txt").y = -24
    // self.star_bubble.setVisible(true)
    // self.star_bubble.getChildByName("prompt_point").scale = 2

    self.star_bubble_select.on(UIButtonEvent.Click, function () {
        self.star_bubble_select.setVisible(false)
        self.star_bubble.setVisible(true)

        // self.comStarBtn.setVisible(false)
        // self.button.setVisible(true)
        self.useComplementStar = false
        self.refreshButton()
        self.dispatchEvent({"name": StartPanelEvent.BubbleClick, "click_type": "no_select"});

    })
    self.star_bubble.on(UIButtonEvent.Click, function () {
        self.star_bubble_select.setVisible(true)
        self.star_bubble.setVisible(false)

        // self.comStarBtn.setVisible(true)
        // self.button.setVisible(false)
        self.useComplementStar = true
        self.refreshButton()
        self.dispatchEvent({"name": StartPanelEvent.BubbleClick, "click_type": "select"});

    })

    self.complementStarTimeLabel =  self.star_bubble.getChildByName("time_bg").getChildByName("num")
    let addLabel = self.star_bubble.getChildByName("txt")
    let addstar_number = MetaManager.getNewAdConfig().addstar_number || 0
    // self.star_bubble.getChildByName("time_bg").setVisible(false)
    addLabel.setString(`分数+${addstar_number}%`)
    addLabel.width = 100
    addLabel.x = 20

    self.complementStarTimeLabel.y = -8
    self.complementStarTimeLabel.width = 100
    let prompt_point =  self.star_bubble.getChildByName("prompt_point")
    let prompt_num =  prompt_point.getChildByName("num")
    prompt_num.width = 50
    let itemNum =  ComplementStarManager.getInstance().getItemNum()
    let itemNumStr = itemNum <= 9 ? itemNum : "9+"
    prompt_num.setString(itemNumStr)
    // prompt_num.setAnchorPoint(0.5,1)
    // prompt_num.setPosition(20,-8)

    let timeBg = self.star_bubble.getChildByName("time_bg")

    
    let updateTimeShowUI = (flag)=>{
        timeBg.setVisible(flag)
        // self.complementStarTimeLabel.setVisible(flag)
        // self.complementStarTimeLabel.setString("00:00:00")
        addLabel.y = flag ?-55:-45
    }
    let itemUseId = ComplementStarManager.getInstance().getItemUseId()
    let expireTime = UserManager.getInstance().getFirstTimePropExpireTime(itemUseId)
    self.complement_star_time = expireTime - Localhost.time()
    if (self.complement_star_time > 0){
        updateTimeShowUI(true)
        self.complementStarTimeLabel.setString("00:00:00")
        // self.complement_star_time = getDayRemainTime()
        self.complementStarTimeTask = setInterval(() => {
            if (!self){
                return
            }
            // cc.log("[Piggy Bank]", "lastTimeTask");
            self.complement_star_time -= 1000;
            if (self.complement_star_time <= 0) {
                self.complement_star_time = 0;
                clearInterval(self.complementStarTimeTask);
                // 判断是否选中了补星瓶
                if(self.star_bubble.isVisible()){
                    cc.log("[AddStar] complementStarTimeTask 当前未选中精力瓶不做处理 ")
                    prompt_num.setString(ComplementStarManager.getInstance().getItemNum())
                    updateTimeShowUI(false)
                }else{
                    cc.log("[AddStar] complementStarTimeTask 当前选中精力瓶进行校验处理 ")
                    // 结束了判断是否有普通道具，有就
                    if (ComplementStarManager.getInstance().getItemNum() > 0){
                        prompt_num.setString(ComplementStarManager.getInstance().getItemNum())
                        updateTimeShowUI(false)
                        self.dispatchEvent({"name": StartPanelEvent.BubbleClick, "click_type": "select","propId": ComplementStarManager.getInstance().getItemUseId()});
                    }else{
                        self.bubbleNode.setVisible(false)

                        // self.star_bubble_select.setVisible(false)
                        // self.star_bubble.setVisible(false)
                        // self.comStarBtn.setVisible(false)
                        // self.button.setVisible(true)
                        self.useComplementStar = false
                        self.refreshButton()
                        self.dispatchEvent({"name": StartPanelEvent.BubbleClick, "click_type": "no_select"});
                    }
                }
    
            }
            self.complementStarTimeLabel.string = parseTimeToHMS(self.complement_star_time);
    
        }, 1000);
    }else{
        updateTimeShowUI(false)
    }
    

}


StartPanel.prototype.initAdStartButton = function () {
    let self = this

    //看广告开始按钮
    self.btn_start_ad = UIButton.create(self.btn_start_ad)
    self.btn_start_ad.on(UIButtonEvent.Click, function () {
        GameSpeedManager.getInstance().isReplayPanel = false
        self.dispatchEvent(table([1, "name", StartPanelEvent.AdStartClick]))
    })

    // 气泡
    self.start_ad_bubble.setVisible(false)
    if (!self.adStartReward){ //不能看广告开始
  
    }else{
        // self.adStartBtn.getChildByName("normal").setScale(0.1)
        DCAssist.dc4User101("bef_stage_ad","ad_button_show",{session: AdStartPropManager.getInstance().createDCSession()})
        let startX = $len(self.adStartReward )> 1 ? -120 : -80 
        for (var i = 1; i < self.adStartReward.length; i++){
            // console.log("adstart self.adStartReward[i]", self.adStartReward[i])
            // let index = i == 1 ? "" : i
            // var ph = self.start_ad_bubble.getChildByName("icon"+ tostring(index))
            var sprite = UIItemBuilder.createPropIcon(self.adStartReward[i])
            sprite.scale = 0.6
            sprite.setPosition(startX + (i-1)*60,-50)
            // sprite.setScale(size.width * scale / sprite.getContentSize().width)
            // sprite.setPosition(cc.p(size.width * scale / 2, size.height * ph.getScaleY() / 2))
            // ph.setSpriteFrame(sprite.getSpriteFrame())
            self.start_ad_bubble.addChild(sprite)
        }

    }
    // self.adStartBtn.ani = cc.CSLoader.createTimeline("cocos/level_difficulty_btn_pink_start.csb")
    // self.adStartBtn.runAction(self.adStartBtn.ani)
    // self.adStartBtn.ani.gotoFrameAndPlay(0, true)
    // SpriteUtil.findBlendChilds_AddOneOne(self.adStartBtn, false)
    

    // //气泡
    // self.bubble = self.getChildByName("champion_gq_popo")
    // if (!self.adStartReward){ //不能看广告开始
    //     self.button.x += 125
    //     self.adStartBtn.setVisible(false)
    //     self.bubble.setVisible(false)
    // }else{
    //     // self.adStartBtn.getChildByName("normal").setScale(0.1)
        
    //     self.bubble.getChildByName("lab_1").y -= 5

    //     for (var i = 1; i < self.adStartReward.length; i++){
    //         // console.log("adstart self.adStartReward[i]", self.adStartReward[i])
    //         var ph = self.bubble.getChildByName("icon"+ tostring(i))
    //         var sprite = UIItemBuilder.createPropIcon(self.adStartReward[i])
    //         var size = ph.getContentSize()
    //         var scale = ph.getScaleX()
    //         sprite.setScale(size.width * scale / sprite.getContentSize().width)
    //         sprite.setPosition(cc.p(size.width * scale / 2, size.height * ph.getScaleY() / 2))
    //         ph.setSpriteFrame(sprite.getSpriteFrame())
    //     }

    // }



}


StartPanel.prototype.onEnter = function () {
    let self = this
    BasePanel.prototype.onEnter.call(self)
    setTimeout(()=>{
        if (!self || self.isClosed) return
        self.initActBanner()
    },200)
    // 开始面板可能在关末/游戏中打开，因此需要缓存上一个进入方式
    self.cachedMarketEntry = MarketManager.getInstance().getRealCashGoodsEntry4dc();
    MarketManager.getInstance().setCashGoodsEntry(MarketManager.CashGoodsEntry.BuyPropBeforeStage);
    GameResLoad.getInstance().checkPreload()

    NuclearBirdManager.getInstance().updateIcon(null,true)


}
StartPanel.prototype.onEnterAnimFinish = function () {
    let self = this
    try {
        let nuclearData = NuclearBirdManager.getInstance().getData()
        if (nuclearData.isNeedGuideLevelPanel() && self.superBirdNode.isVisible() && !self.isReplay){
            let guideNode = cc.Node.create()
            self.addChild(guideNode)
            guideNode.setLocalZOrder(99999)
            guideNode.scale = 1/self.scale
            guideNode.setPosition(-display.width/2 * guideNode.scale,-display.height/2 * guideNode.scale)
            NuclearBirdManager.getInstance().showStartPanelGuide([self.superBirdNode],1,guideNode)
        }
    } catch (error) {
        cc.error(error)
    }
}
/**
 * 播放消耗精力进关卡动画
 */
StartPanel.prototype.playConsumeEnergyAnimation = function (callback) {
    // callback && callback()
    var self = this
    if (self.energy_num && !self.useEnergyPropId && !self.isClosed) {//点击开始后，精力不足会跳转到EnergyPanel，该面板会销毁isClosed
        var pos = require("clover/scene/HomeScene").getInstance().infoBanner.getEnergyIconPositon()
        var pos_to = self.startBtn.convertToWorldSpace(cc.p(self.energy_icon.getPosition()))
        cc.log("tarPos pos_to",pos_to)
        var flyTime = 0.3
        var icon = cc.Sprite.createWithSpriteFrameName("start_main/mc_energy_up.png")
        icon.setAnchorPoint(cc.p(0.5, 0.5))
        icon.setScale(0.55)
        var scene = cc.Director.getInstance().getRunningScene()
        scene.addChild(icon, 1000)
        icon.setPosition(pos)
        var panel = self
        function flyEnd() {
            // body
            panel.energy_icon.setVisible(true)
            if(!self.energy_num.isRunning()){
                icon.removeFromParent(true)
                callback()
            }
            self.startBtn.getChildByName("num").setColor(cc.c3b(255, 255, 255))
        }
        icon.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(flyTime, 0.55), cc.MoveTo.create(flyTime, pos_to))), cc.CallFunc.create(flyEnd)))
        self.energy_num.setVisible(true)
        if(self.energy_num.isRunning()){
            var action = cc.Sequence.create(cc.DelayTime.create(flyTime), cc.EaseSineOut.create(cc.FadeIn.create(0.1)), cc.DelayTime.create(0.2), cc.CallFunc.create(() => {
                icon.removeFromParent(true)
                callback()
            }))
            self.energy_num.runAction(action)
        }
    } else { //------------不需要消耗精力
        self.useEnergyPropId = 0;
        callback()
    }
}
StartPanel.prototype.cleanup = function () {
    var self = this
    self.isClosed = true;
    // 去除加在 bubble 上的listener
    for (var key in self.preProps) {
        var element = self.preProps[key];
        if (element.bubble && element.bubble.listenner) {
            cc.eventManager.removeListener(element.bubble.listenner)
        }
    }
    self.rankBtn1 = null;
    self.rankBtn2 = null;
    self.friendRank = null;
    clearInterval(self.complementStarTimeTask);

    if (self.adPrepropCmpt) {
        self.adPrepropCmpt.destroy();
        self.adPrepropCmpt = null;
    }

    if (self._kMedalRankOpen) {
        GlobalEventDispatcher.getInstance().removeEventListener(
            kGlobalEvents.kMedalRankOpen,
            self._kMedalRankOpen
        );
        self._kMedalRankOpen = null;
    }

    BasePanel.prototype.cleanup.call(self)
    // cc.SpriteFrameCache:getInstance():removeSpriteFramesFromFile("cocos/level_panel.plist")
    // cc.Director:getInstance():getTextureCache():removeTextureForKey("cocos/level_panel.png")
    PaymentGuideManager.getInstance().setInStartpanel(false)
    ResManager.release(StartPanel.RES );
   this.cleanTimer()
   NuclearBirdManager.getInstance().hideStartPanelGuide()
}
StartPanel.prototype.cleanTimer = function () {
    let self = this
    if ( self._schedulerId_seasideStar){
        cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_seasideStar);
        self._schedulerId_seasideStar = null;
    }
    if ( self._schedulerId_qualify){
        cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_qualify);
        self._schedulerId_qualify = null;
    }
    
}
// 数字取自level_type.image.fla
var levelTypeToAnchorPointRef = table([1, GameLevelType.kHiddenLevel, cc.p(-125 / 354, (167.25 - 127.65) / 256)])
var gameplayModeToAnchorPointRef = table(
    [1, GamePlayType.kOrder, cc.p(-11.10 / 301.25, (177.50 - 135.25) / 177.50)],
    [1, GamePlayType.kIce, cc.p(-29.65 / 253.75, (207.50 - 192.40) / 207.50)],
    [1, GamePlayType.kFish, cc.p(10.35 / 288.15, (186.25 - 172.30) / 186.25)],
    [1, GamePlayType.kBlockCollection, cc.p(-22.45 / 258.15, (144.40 - 127.50) / 144.40)],
    [1, GamePlayType.kBoss, cc.p(-21.90 / 217.50, (193.75 - 163.30) / 193.75)],
    [1, GamePlayType.kWaterDig, cc.p(-35.3 / 241.9, (173.05 - 147.2) / 173.05)],
    [1, GamePlayType.kPursue, cc.p(44.95 / 322, (241 - 198.55) / 241)]
)
StartPanel.prototype.buildLevelInfo = function () {
    var self = this
    let startTitle = null
    self.tittleNode.getChildByName("start_tittle_hard").setVisible(false)
    self.tittleNode.getChildByName("start_tittle_medium").setVisible(false)
    self.tittleNode.getChildByName("start_tittle_normal").setVisible(false)

    if (self.scoreConfig.isHardLevel) {
        startTitle = self.tittleNode.getChildByName("start_tittle_hard")
    }else if (self.scoreConfig.totalStar > 3) {
        startTitle = self.tittleNode.getChildByName("start_tittle_medium") //4星关
    }else{
        startTitle = self.tittleNode.getChildByName("start_tittle_normal")
        startTitle.getChildByName("com_detail").setVisible(false)
        let headLab = startTitle.getChildByName("txt2")
        headLab.setString("关卡")

    }
    startTitle.setVisible(true)
    let numLab = startTitle.getChildByName("num")
    let headLab = startTitle.getChildByName("txt2")
    numLab.string =  self.levelInfo.levelId
    let middleX = startTitle.width/2
    headLab.x = -(headLab.width * headLab.scale + numLab.width * numLab.scale)/2 + headLab.width/2 * headLab.scale  + middleX
    numLab.x = headLab.x + headLab.width/2 * headLab.scale + numLab.width/2 * numLab.scale + 10

    // FrameLoader.loadImageWithPlist("cocos/level_type_image.plist")
    // if (self.levelInfo.levelType) {
    //     var image = cc.Sprite.createWithSpriteFrameName("level_type_image/res_level_type" + tostring(self.levelInfo.levelType) + ".png")
    //     if (image) {
    //         image.setAnchorPoint(clone(levelTypeToAnchorPointRef[self.levelInfo.levelType || 0]) || cc.p(0, 1))
    //         image.setName("level_type")
    //         image.setLocalZOrder(-10)
    //         self.addChild(image)
    //     }
    // } else if (self.levelInfo.gameplayMode) {
    //     var image = cc.Sprite.createWithSpriteFrameName("level_type_image/res_gameplay_type" + tostring(self.levelInfo.gameplayMode) + ".png")
    //     if (image) {
    //         image.setAnchorPoint(clone(gameplayModeToAnchorPointRef[self.levelInfo.gameplayMode || 0]) || cc.p(0, 1))
    //         image.setName("level_type")
    //         image.setLocalZOrder(-10)
    //         self.addChild(image)
    //     }
    // }
    // var level = self.getChildByName("levelx")
    // var levelId  = level.getChildByName("num")
    // var levelIdL = level.getChildByName("txt")
    // var levelIdR = level.getChildByName("txt2")

    // if (self.levelInfo.levelId) {
    //     var bg = self.getChildByName("panel_sandbeach")
    //     levelId.ignoreContentAdaptWithSize(true)
    //     levelId.setString(self.levelInfo.levelId)
    //     var size = levelId.getVirtualRendererSize()
    //     var bgSize = bg.getContentSize()
    //     var levelIdSize = levelId.getVirtualRendererSize()
    //     level.setPosition(bgSize.width / 2, level.getPosition().y + 10)
    //     levelId.setPositionX(- levelIdSize.width / 2)
    //     levelId.setScale(1.1, 1.1)
    //     levelIdL.ignoreContentAdaptWithSize(true)
    //     levelIdL.setString(getText("start.panel.level.left"))
    //     var size2 = levelIdL.getVirtualRendererSize()
    //     levelIdL.setPosition(cc.p(levelId.getPositionX() - size2.width * levelIdL.getScaleX() - 10, levelId.getPositionY() - size.height * levelId.getScaleY() + size2.height * levelIdL.getScaleY()))
    //     levelIdR.ignoreContentAdaptWithSize(true)
    //     levelIdR.setString(getText("start.panel.level.right"))
    //     var size3 = levelIdR.getVirtualRendererSize()
    //     levelIdR.setPosition(cc.p(levelId.getPositionX() + size.width * levelId.getScaleX() + 10, levelId.getPositionY() - size.height * levelId.getScaleY() + size3.height * levelIdL.getScaleY()))
    // }
    // // if (self.levelInfo.notFinish) {
    // //     var ui = HideAreaLevelContainer.create(self.levelInfo.hideGroupId, true)
    // //     ui.updateState(self.levelInfo.hideStatus)
    // //     var bg = self.getChildByName("bg")
    // //     var bgSize = bg.getContentSize()
    // //     ui.setPosition(cc.p(bgSize.width / 2, -20))
    // //     self.addChild(ui)
        
    // // }

}
StartPanel.prototype.closeTipbox = function () {
    var self = this
    if (self.tipBox) {
        self.tipBox.stopAllActions()
        self.tipBox.close()
    }
}

StartPanel.prototype.buildStar = function () {
    var self = this
    self.tittleNode.getChildByName("3star").setVisible(false)
    self.tittleNode.getChildByName("4star").setVisible(false)
    let stared = self.tittleNode.getChildByName("3star")
    if (self.scoreConfig.totalStar > 3) {
        stared = self.tittleNode.getChildByName("4star")
    }
    if (self.scoreConfig.star > 0){
        stared.setVisible(true)
    }

    for (var i = 1; i <= self.scoreConfig.totalStar; i += 1) {
        cc.log("buildStar ",i)
        stared.getChildByName("star_"+i).getChildByName("start_star_light").setVisible(self.scoreConfig.star >= i)
    }
    // var stared = self.getChildByName("3stars")
    // stared.setPosition(stared.getPositionX() + stared.getContentSize().width / 2, stared.getPositionY() - 70)
    // if (self.scoreConfig.totalStar > 3) {
    //     //  四星的时候会遮盖到关闭按钮，所以向左移了10个像素
    //     stared.setPositionX(stared.getPositionX() - 10)
    // }
    // stared.removeAllChildrenWithCleanup(true)
    // var staredPos = cc.p(stared.getPosition())
    // if (self.levelInfo.levelType) {
    //     staredPos = cc.p(staredPos.x, staredPos.y - 30)
    // }
    // self.starAnimationList = table()
    // var centerIndex = self.scoreConfig.totalStar / 2 + 0.5
    // var $limit74 = self.scoreConfig.totalStar
    // for (var i = 1; i <= $limit74; i += 1) {
    //     var count = i - centerIndex
    //     var absCount = Math.abs(count)
    //     var absDuoCount = absCount * 2
    //     var angle = 0
    //     if (i !== centerIndex) {
    //         angle = 10 * Math.pow(1.5, (Math.ceil(absCount) - 1))
    //     }
    //     angle = count > 0 && angle || -angle
    //     var posAngle = 0
    //     if (i !== centerIndex) {
    //         posAngle = 5.5 * (absDuoCount - 1) + 5.7
    //     }
    //     posAngle = count > 0 && posAngle || -posAngle

    //     var sprite
    //     if (i <= self.scoreConfig.star) {
    //         if (i >= 4) {
    //             sprite = cc.CSLoader.createNode("cocos/uilibrary_starsstar_blueglow.csb")
    //             var action = cc.CSLoader.createTimeline("cocos/uilibrary_starsstar_blueglow.csb")
    //             sprite.runAction(action)
    //             action.gotoFrameAndPlay(0)
    //         } else if (i >= 3) {
    //             // sprite = cc.Sprite:createWithSpriteFrameName("uilibrary/starstar_redglow.png")
    //             sprite = cc.CSLoader.createNode("cocos/uilibrary_starstar_redglow.csb")
    //             var action = cc.CSLoader.createTimeline("cocos/uilibrary_starstar_redglow.csb")
    //             sprite.runAction(action)
    //             action.gotoFrameAndPlay(0)
    //         } else {
    //             sprite = cc.Sprite.createWithSpriteFrameName("uilibrary/star2_full.png")
    //         }
    //     } else {
    //         sprite = cc.Sprite.createWithSpriteFrameName("uilibrary/star1_empty.png")
    //     }
    //     sprite.setRotation(angle)
    //     sprite.setScale(Math.pow(0.8, Math.floor(absCount)))
    //     var pos = cc.pRotateByAngle(staredPos, cc.p(staredPos.x, staredPos.y - 640), -posAngle * Math.PI / 180)
    //     sprite.setPosition(cc.p(pos.x, pos.y))
    //     self.starAnimationList[i] = sprite
    //     self.addChild(sprite)
    //     self.starBasePos = cc.p(staredPos.x, staredPos.y - 640)
    // }
    // stared.removeFromParent(true)
}

StartPanel.prototype.buildBattlePassHint = function () {
    var self = this

    if (BattlePassLogic.getInstance().canGetKey(self.levelId)){
        self.getChildByName("tips").setVisible(true)
        self.getChildByName("keyicon").setVisible(true)
        self.getChildByName("tips").setFontSize(22)
        self.getChildByName("keyicon").setScale(1.25)

        const ishard = LevelConfigManager.getInstance().getHardLevel(self.levelId);
        self.getChildByName("tips").setString("通关可获得n个".replace("n", BattlePassLogic.getInstance().getKeyNum(ishard)))

        self.getChildByName("keyicon").x += 20
        // self.getChildByName("tips").y -= 5
        let tips = self.getChildByName("tips")
        tips.setContentSize(tips.getVirtualRenderer().getContentSize())
        
    }else {
        self.getChildByName("tips").setVisible(false)
        self.getChildByName("keyicon").setVisible(false)
    }
    
}
StartPanel.prototype.buildNuclearBirdUI = function () {
    let self = this
    // cleanAddKeyNum
    self.superBirdNode = self.getChildByName("superbird")
    // self.superBirdNode.setVisible(false)


    let nuclearMgr = NuclearBirdManager.getInstance()
    let nuclearData = nuclearMgr.getData()
    let targetNum = nuclearData.getTargetNum()
    let passNum = nuclearData.getPassNum()
    let info = nuclearData.getInfo()
    let onInfo = nuclearData.getOnInfo()
    if (!nuclearMgr.isOpen(true) || info.state == NuclearBirdManager.STATE.end ) {
        self.superBirdNode.setVisible(false)
        return
    }


    let numLabel = self.superBirdNode.getChildByName("num")
    numLabel.ignoreContentAdaptWithSize(true)
    
    try {       

        let bar = cc.Sprite.createWithSpriteFrameName("start_main/start_superbird_2.png")
        let progressTimer = cc.ProgressTimer.create(bar);
        progressTimer.setType(cc.PROGRESS_TIMER_TYPE_RADIAL);
        // progressTimer.setType(cc.PROGRESS_TIMER_TYPE_BAR);
        progressTimer.setAnchorPoint(0.5, 0.5);
        progressTimer.setScale(1);
        progressTimer.setMidpoint(cc.p(0.5, 0.5))
        progressTimer.setPercentage(0)
        progressTimer.setScale(-1);
        progressTimer.setPosition(-5,16)
        self.superBirdNode.addChild(progressTimer)

        let iconSp = sp.SkeletonAnimation.create("spine/nuclear_bird/supermagicbird_bird.skel", "spine/nuclear_bird/supermagicbird_bird.atlas", 1)
        iconSp.setAnimation(0, "0_idle", true)
        self.superBirdNode.addChild(iconSp)
        iconSp.setPosition(-5,16)
        iconSp.scale = 0.8
    
        nuclearMgr.dcNuclearBirdNormal("icon_show", null, {
            current_stage: self.levelId,
            type: nuclearMgr.dcGetStateStr(info.state)
        })

        if(self.isReplay && info.state == NuclearBirdManager.STATE.active){
            numLabel.setString("0/"+targetNum)
            return
        }
        this.superBirdBtn = UIButton.create(self.superBirdNode);
        this.superBirdBtn.on(UIButtonEvent.Click, ()=>{
            let self = this
            if (self.isBusy) return
            // self.isBusy = true
            let state = nuclearData.getInfo().state
            let dc_session = nuclearMgr.dcNuclearBirdNormal("icon_click", null, {
                current_stage: self.levelId,
                type: nuclearMgr.dcGetStateStr(info.state)
            })
            nuclearMgr.hideStartPanelGuide()
            if (state == NuclearBirdManager.STATE.wait_active) {
                nuclearMgr.showStartPanel(null, {
                    session: dc_session
                })
            } else if (state == NuclearBirdManager.STATE.active) {
                nuclearMgr.showActivatePanel(null, {
                    session: dc_session
                })
            }
      
        });
    
        cc.log("[NuclearBird] buildNuclearBirdUI ",passNum,targetNum,info)
        let progress = 100 * passNum / targetNum
        if (onInfo && info.state != NuclearBirdManager.STATE.active) {
            cc.log("[NuclearBird] buildNuclearBirdUI info ",onInfo.passNum,onInfo.state)
            numLabel.setString(onInfo.passNum+"/"+targetNum)
            let on_progress = 100 * onInfo.passNum / targetNum
            progressTimer.setPercentage(on_progress)
            progressTimer.runAction(cc.Sequence.create(
                cc.ProgressTo.create(0.7, progress),
                cc.CallFunc.create(() => {
                    numLabel.setString(passNum+"/"+targetNum)
                })
            ))
        }else{
            numLabel.setString(passNum+"/"+targetNum)
            progressTimer.setPercentage(progress)
            if (info.state == NuclearBirdManager.STATE.active){
               iconSp.setAnimation(0, "1_idle", true)
            }
        }
    } catch (error) {
        cc.error(error)
    }
    
    nuclearData.setOnInfo(info)
}
StartPanel.prototype.buildBuffProp = function () {
    let self = this
    let isPassTopLvFirst = !UserManager.getInstance().reachTopLevel() && self.levelId == UserManager.getInstance().user.topLevelId
    if (!isPassTopLvFirst && !LevelType.isMysteryIslandLevel(self.levelId)) {     
        return
    }

    // 判断条件后续如果有其他buff类型的关前道具 可以考虑把下面判断方法抽出来
    let leftNum = SalvageGiftManager.getInstance().getData().getLeftAddStepLevelNum()
    if (leftNum <= 0 ) return
    self.buffBubble = cc.CSLoader.createNode("cocos/level_difficulty_bubble_props_buff.csb")
    self.selectNode.addChild(self.buffBubble)
    let posY = 0
    if (PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId)){
        posY = 10
    }
    self.buffBubble.scale = 0.85
    self.buffBubble.setPosition(225,posY)
    self.buffBubble.getChildByName("use").setScale(1.2)
    self.buffBubble.getChildByName("use").y += 2
    let icon = UIItemBuilder.createProp(56, 1, null, null, true)[0]
    icon.y = -5
    self.buffBubble.getChildByName("checkmrak").setScale(1)
    self.buffBubble.getChildByName("checkmrak").setLocalZOrder(2)
    self.buffBubble.addChild(icon)

    let promptDot = require("clover/scene/component/homescene/PromptTip").create();
    promptDot.setNum(leftNum);
    promptDot.setPosition(self.buffBubble.getContentSize().width/2 - 28, 55);
    self.buffBubble.addChild(promptDot)
}
StartPanel.prototype.buildPreProps = function () {
    let self = this
    for (var i = 1; i <= 3; i += 1) {
        let bubble = cc.CSLoader.createNode("cocos/level_difficulty_bubble_props.csb")
        self.selectNode.addChild(bubble)
        let posY = 0
        if (PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId)){
            posY = 10
        }
        let posX = -180
        let offset = 180
        if (self.buffBubble){
            posX = -225
            bubble.scale = 0.85
            offset = 150
        }
        bubble.setPosition(posX + (i-1)*offset,posY)
        var config = self.initPropConfig[i]
        config.index = i
        let bubbleIdle = bubble.getChildByName("bubble_idle")                                     
        let bubbleLock = bubble.getChildByName("bubble_lock")     
        let bubblePop = bubble.getChildByName("bubble_pop")   
        let bubbleAppear = bubble.getChildByName("bubble_appear")   
           
        let lock = bubble.getChildByName("lock")  
        let numLabel = bubble.getChildByName("dot")
        numLabel.setLocalZOrder(90)
        numLabel.text = numLabel.getChildByName("num")
        numLabel.text.setFontWeight("bold")
        numLabel.textAdd = numLabel.getChildByName("numfuhao")
        numLabel.textAdd.setFontWeight("bold")
        numLabel.text.ignoreContentAdaptWithSize(true)
    
        let checkmark = bubble.getChildByName("checkmrak")
        let backgrnd = bubble.getChildByName("start_bubble_bg")
        let ad_btn = bubble.getChildByName("ad_btn")
        
        ad_btn.setVisible(false)
        // let backgrnd = cc.Node.create()
        // bubble.addChild(backgrnd)
        let labelBg = bubble.getChildByName("buy")
        bubble.labelBg = labelBg
        let preProp = PreProps.create(table(
            [1, "bubble", bubble],
            [1, "bubbleIdle", bubbleIdle],
            [1, "bubbleLock", bubbleLock],
            [1, "bubblePop", bubblePop],
            [1, "bubbleAppear", bubbleAppear],

            //[1, "tab", tab],
            //[1, "num", num],
            [1, "lock", lock],
            [1, "numLabel", numLabel],
            //[1, "disableIcon", disableIcon],
            [1, "checkmark", checkmark],
            [1, "ad_btn", ad_btn],
            [1, "backgrnd", backgrnd]
        ), config)
        if (!config.expireTime || config.litmitedProp){
            preProp.on(PrePropsEvent.Select, handler(self, self.onSelectProp))
            preProp.on(PrePropsEvent.Cancel, handler(self, self.onCancelProp))
        }
        table.insert(self.preProps, preProp)
    }
    // var self = this
    // FrameLoader.loadImageWithPlist("cocos/level_panel.plist")
    // let bubblePanel = null
    // if (self.scoreConfig.isHardLevel) {
    //     //  展示困难关面板
    //     self.getChildByName("blue").setVisible(false)
    //     bubblePanel = self.getChildByName("purple")
    // } else {
    //     //  展示普通面板
    //     self.getChildByName("purple").setVisible(false)
    //     bubblePanel = self.getChildByName("blue")
    // }

    // bubblePanel.setLocalZOrder(100)
    // bubblePanel.setPositionX(bubblePanel.getPositionX() - 4)
    // self.txtTip = bubblePanel.getChildByName("txt_tip")
    // self.txtTip.setFontSize(24)
    // self.txtTip.setFontWeight("bold")
    
    // self.txtTip.setString(getText("hard.level.tips"))
    // self.txtTip.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    // self.txtTip.setPositionX(bubblePanel.getContentSize().width / 2 - self.txtTip.getContentSize().width / 2)
    // self.bubblePanel = bubblePanel
    // for (var i = 1; i <= 3; i += 1) {
    //     var bubble = bubblePanel.getChildByName("bubble_props" + tostring(i))                
    //     bubble.setLocalZOrder(1)
    //     var bubbleIdle = bubble.getChildByName("bubble_idle")                                     
    //     var bubbleLock = bubble.getChildByName("bubble_lock_" + bubblePanel.getName())      
    //     var bubblePop = bubble.getChildByName("bubble_pop")              
    //     //var tab = bubble.getChildByName("silvercoin_" + bubblePanel.getName())                                                    
    //     //var num = tab.getChildByName("num")
    //     //num.setFontStyle("normal") 
    //     var lock = bubble.getChildByName("lock")
    //     var numLabel = bubble.getChildByName("dot")
    //     var checkmark = bubble.getChildByName("checkmrak")
    //     numLabel.setLocalZOrder(90)
    //     //numLabel.setVisible(false)
    //     numLabel.text = numLabel.getChildByName("num")
    //     numLabel.text.setFontWeight("bold")
    //     numLabel.textAdd = numLabel.getChildByName("numfuhao")
    //     numLabel.textAdd.setFontWeight("bold")
    //     // var size = numLabel.getContentSize()
    //     // numLabel.text.setAnchorPoint(cc.p(0.5, 0.5))
    //     // numLabel.text.setPosition(cc.p(size.width / 2, -size.height / 2 + 2))
    //     numLabel.text.ignoreContentAdaptWithSize(true)
    //     var backgrnd = bubble.getChildByName("circle_" + bubblePanel.getName())
    //     var labelBg = bubble.getChildByName(bubblePanel.getName() + "_buy")
    //     bubble.labelBg = labelBg
    //     var config = self.initPropConfig[i]
    //     config.index = i
    //     //tab.getChildByName("props_silvercoin").setPositionX(tab.getChildByName("props_silvercoin").getPositionX() - 8)
    //     var preProp = PreProps.create(table(
    //         [1, "bubble", bubble],
    //         [1, "bubbleIdle", bubbleIdle],
    //         [1, "bubbleLock", bubbleLock],
    //         [1, "bubblePop", bubblePop],
    //         //[1, "tab", tab],
    //         //[1, "num", num],
    //         [1, "lock", lock],
    //         [1, "numLabel", numLabel],
    //         //[1, "disableIcon", disableIcon],
    //         [1, "checkmark", checkmark],
    //         [1, "backgrnd", backgrnd]
    //     ), config)
        
    //     if (!config.expireTime){
    //         preProp.on(PrePropsEvent.Select, handler(self, self.onSelectProp))
    //         preProp.on(PrePropsEvent.Cancel, handler(self, self.onCancelProp))
    //     }

    //     table.insert(self.preProps, preProp)
    // }

    //self.updateInitPropAfford()


}
/**
 * 道具气泡被选择回调
 */
StartPanel.prototype.onSelectProp = function (event) {
    var self = this
    var index = table.indexof(self.preProps, event.target)
    if (index) {
        var outEvent = table(
            [1, "name", StartPanelEvent.PrePropSelect], 
            [1, "propId", self.initPropConfig[index].itemId],       //  这两个没写反，请勿更改
            [1, "itemId", self.initPropConfig[index].propId],
            [1, "targetNode", event.target],
            [1, "litmitedProp", self.initPropConfig[index].litmitedProp],
        )
        self.dispatchEvent(outEvent)
        if (outEvent.success) {
            event.target.select(true)
            //self.updateInitPropAfford()
        } else if (outEvent.errCode) {
            event.target.showErrorTip(outEvent.errCode)
        }
    }
    self.updateSelectPropConsumeTip()
}
// 理性消费提示
StartPanel.prototype.updateSelectPropConsumeTip = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    var isShow = false
    for (var k = 1, v = self.preProps[1]; v; k++, v = self.preProps[k]) {
        if (v.isSelected() && v.config.cash && v.config.num <= 0) {
            isShow = true
            break
        }
    }
    if (isShow) {
        VerifiedManager.getInstance().showConsumeTip()
    } else {
        VerifiedManager.getInstance().removeConsumeTip()
    }
}
StartPanel.prototype.updatePrePropNum = function () {
    var self = this
    for (var k = 1, v = self.initPropConfig[1]; v; k++, v = self.initPropConfig[k]) {
        var newNum = UserProp.getInstance().getPropNumber(v.itemId)[0]
        if (newNum !== v.num) {
            self.preProps[k].updateNum(newNum)
        }
        v.num = newNum
    }
}
StartPanel.prototype.selectPreProp = function (itemId) {
    var self = this
    for (var k = 1, v = self.initPropConfig[1]; v; k++, v = self.initPropConfig[k]) {
        if (v.itemId === itemId) {
            var index = k
            var outEvent = table([1, "name", StartPanelEvent.PrePropSelect], [1, "propId", itemId])
            self.dispatchEvent(outEvent)
            if (outEvent.success) {
                self.preProps[index].select(true)
                //self.updateInitPropAfford()
            }
        }
    }
}
StartPanel.prototype.onCancelProp = function (event) {
    var self = this
    var index = table.indexof(self.preProps, event.target)
    if (index) {
        self.dispatchEvent(table([1, "name", StartPanelEvent.PrePropCancel], [1, "propId", self.initPropConfig[index].itemId], [1, "litmitedProp", self.initPropConfig[index].litmitedProp]))
        event.target.select(false)
        //self.updateInitPropAfford()
    }
    self.updateSelectPropConsumeTip()
}
/**
 * 刷新道具可购买状态
 */
// StartPanel.prototype.updateInitPropAfford = function () {
//     var self = this
//     var [coin, cash, rmb] = [0, 0, 0]
//     for (var i = 1, v = self.preProps[1]; v; i++, v = self.preProps[i]) {
//         if (v.isSelected() && self.initPropConfig[i] && self.initPropConfig[i].num <= 0) {
//             if (self.initPropConfig[i].coin) {
//                 coin = coin + (self.initPropConfig[i].discountCoin || self.initPropConfig[i].coin)
//             } else if (self.initPropConfig[i].cash) {
//                 cash = cash + (self.initPropConfig[i].discountCash || self.initPropConfig[i].cash)
//             }
//         }
//     }
//     for (var i = 1, v = self.initPropConfig[1]; v; i++, v = self.initPropConfig[i]) {
//         if (v.num <= 0) {
//             if (v.coin) {
//                 if (self.preProps[i]) {
//                     self.preProps[i].setCanAfford(UserCoin.getInstance().getCoin() - coin >= (v.discountCoin || v.coin))
//                 }
//             } else if (v.cash) {
//                 if (self.preProps[i]) {
//                     var canAfford = UserCash.getInstance().getCash() - cash >= (v.discountCash || v.cash)
//                     if (__ANDROID) {
//                         var supportPayTable = GameProxy.getInstance().getPaymentDicission()
//                         var rmbAvailable = ($len(((supportPayTable || table()).all || table())) > 0)
//                         if (canAfford || !rmbAvailable) {
//                             self.preProps[i].setCanAfford(canAfford)
//                         } else {
//                             var rmb = MarketManager.getInstance().getRmbPrice(v.itemId)
//                             self.preProps[i].setRmbPrice(rmb)
//                         }
//                     } else {
//                         self.preProps[i].setCanAfford(canAfford)
//                     }
//                 }
//             }
//         }
//     }
// }
// 活动逻辑 在这里判断是否需要使用底部 使用底部则排行榜不加载
StartPanel.getBottomType = function () {
    const order = [ 1, 2,10, 8, 3, 4, 5, 6, 11, 7, 9];
    for (let i = 0; i < order.length; i++) {
        if (StartPanel.getActState(order[i])) {
            return order[i];
        }
    }
    return 0;
}
//1. 萌萌竞速开始2. 快艇大赛开始3. 钓鱼活动开始4. 萌萌竞速排名 5. 神秘岛排行榜6. 快艇大赛排名7. 钓鱼活动排名 8 冠军赛开始 9 冠军赛排名 10 投篮开始 11 投篮排名
StartPanel.getActState = function (id = 0) {
    let lMgr = LightningRushManager.getInstance();
    switch (id) {
        case 1:
            if (lMgr.isOpen()) {
                const state = lMgr.getState();
                if (state == LightningRushManager.ACT_STATE.NOT_JOIN && lMgr.getRemainingTime() <= 0) {

                } else {
                    if (state == LightningRushManager.ACT_STATE.NOT_JOIN) {
                        return true
                    }
                }
            }
            break;
        case 2:
            if (!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1) {
                if (SpeedboatMatchManager.getInstance().isOpen()) {
                    const stage = SpeedboatMatchManager.getInstance().getActState();
                    if (stage == 1) {
                        return true
                    }
                } else {
                    //
                    DAManager.getInstance().clearAdjustStrategy("speedboat_match");
                }
            }
            break;
        case 3:
            if (!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1) {
                const state = FishingManager.getInstance().getActState();
                if (state == 1) {
                    return true;
                }
            }
            break;
        case 4:
            if (lMgr.isOpen()) {
                const state = lMgr.getState();
                if (state == LightningRushManager.ACT_STATE.NOT_JOIN && lMgr.getRemainingTime() <= 0) {

                } else {
                    if (state != LightningRushManager.ACT_STATE.NOT_JOIN) {
                        return true
                    }
                }
            }
            break;
        case 5:
            if (!LevelType.isMysteryIslandLevel(StartPanel.curLevelId) && MysteryIslandManager.getInstance().isOpenRank()) {
                return true;
            }
            break;
        case 6:
            if (!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1) {
                if (SpeedboatMatchManager.getInstance().isOpen()) {
                    const stage = SpeedboatMatchManager.getInstance().getActState();
                    if (stage == 2) {
                        return true
                    }
                } else {
                    //
                    DAManager.getInstance().clearAdjustStrategy("speedboat_match");
                }
            }
            break;
        case 7:
            if (!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1) {
                const state = FishingManager.getInstance().getActState();
                if (state == 2) {
                    return true;
                }
            }
            break;
        case 8:
            if ((!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1)
                && UserManager.getInstance().getGroupByKey("champion_banner_abtest") != "a" && ChampionLogic.getInstance().isChampionOpen() && !ChampionLogic.getInstance().inSeason() 
                // && !ChampionLogic.getInstance().cantJoin()
                // && !ChampionLogic.getInstance().joinError()
                && !ChampionLogic.getInstance().isInForbidden()
                && !ChampionLogic.getInstance().activityFinish()){
                return true
            }
            break;
        case 9:
            let championMgr = ChampionLogic.getInstance()
            if ((!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1)
                && !ChampionLogic.getInstance().isInForbidden()
                && !ChampionLogic.getInstance().cantJoin()
                && !ChampionLogic.getInstance().joinError()
                && UserManager.getInstance().getGroupByKey("champion_banner_abtest") != "a" && championMgr.isChampionOpen() && championMgr.inSeason() && !championMgr.activityFinish()){
                return true
            }
            break;
        case 10:
            if ((!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1)
                &&  DunkAceData.getInstance().inJoinTime()
                // && !ChampionLogic.getInstance().cantJoin()
                // && !ChampionLogic.getInstance().joinError()
                ){
                return true
            }
            break;
        case 11:
            if ((!StartPanel.scoreConfig || StartPanel.scoreConfig.star < 1)
                &&  DunkAceData.getInstance().inPlayTime()
                ){
                return true
            }
            break;
    }
    return false;
}

StartPanel.getBottomRes = function (type) {
    let temp = {
        1: "packed/LightningRushBanner.pack",
        2: "packed/SpeedboatMatchBanner.pack",
        3: "packed/FishingBanner.pack",
        4: "packed/LightningRushBanner.pack",
        5: "packed/MysteryIslandRank.pack",
        6: "packed/SpeedboatMatchBanner.pack",
        7: "packed/FishingBanner.pack",
        8: "packed/ChampionBanner.pack",
        9: "packed/ChampionBanner.pack",//ChampionBanner
        10: "packed/DunkAceBanner.pack",
        11: "packed/DunkAceBanner.pack",
    }
    return temp[type] || "";
}
StartPanel.prototype.onCloseByBanner = function () {
    var self = this
    self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
}
/**
 * 创建排行榜
 */
StartPanel.prototype.buildRank = function () {
    let self = this;
    if(self.friendRank) return;
    const friendType =  UserManager.getInstance().getFriendRankType();
    let loadCb = function(medalData) {
        if(friendType || medalData) {
            if(self.isClosed) return;
            //打点
            let pf = "friend_rank";
            if(!friendType || (medalData && medalData.rank > 0)) {
                pf = "global_rank";
            }
            self.dcPageShow(pf);
            //
            self.friendRank = MedalRankList.create(self.levelId, medalData, self.params, "stage_start_rank_click");
            self.friendRank.setAnchorPoint(cc.p(0.5, 0));
            //设置排行榜所在的位置
            let posY = -display.height / 2 /self._scale + self.friendRank.height / 2;
            if (cc.sys.os === cc.sys.OS_IOS && display.height / display.width > 1.78) {
                posY += 20;
            }
            self.friendRank.setPosition(cc.p(display.width / 2, posY));
            self.addChild(self.friendRank);
            self.friendRank.setLocalZOrder(9999);
        }
    }
    const isMystery = LevelType.isMysteryIslandLevel(self.levelId);
    if(UserManager.getInstance().supportMedal() && !isMystery) {
        MedalRankManager.getInstance().getLevelScoreRankList(self.levelId).then((data)=>{
            //提前加载，如果没有勋章列表，则不展示勋章tab
            loadCb(data);
        }).catch(()=>{
            loadCb();
        })
    } else {
        loadCb();
    }
}
//适配含有紫咪或者勋章榜的ui位置
StartPanel.prototype.fitMedalAndPurpleAmy = function () {
    let self = this
    let bgBottom = self.getChildByName("start_main_bg02")
    bgBottom.y += 80;
    self.startNode.y += 80;
    self.selectNode.y += 110;
}

StartPanel.prototype.initMedal =function() {
    let self = this;
    //
    let loadCb = function(data) {
        //不显示勋章的时候判断是否显示紫咪
        const showPurpleAmy = PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId);
        if(!showPurpleAmy && (!data || !data.levelMedal) ) {
            self.fitMedalAndPurpleAmy();
        }
    }
    const topLevelId = UserManager.getInstance().user.topLevelId;
    if(UserManager.getInstance().supportMedal() && topLevelId > self.levelId) {
        MedalRankManager.getInstance().getLevelScoreRankInfo(self.levelId).then((data)=>{
            if(data) {
                if(data.levelMedal && data.levelScoreRank) {
                    self.buildMedalRank(data);
                }
                loadCb(data);
            }else {
                //
                loadCb();
            }
        }).catch(()=>{
            loadCb();
        })
    } else {
        loadCb();
    }
}

StartPanel.prototype.onClickEmpty = function () {
    var self = this
    if ( this.actBanner){
        this.actBanner.onClickEmpty()
    }
    //self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
}
StartPanel.prototype.getPrePropPositionAndScaleInWorldSpace = function (index) {
    var self = this
    index = cc.clampf(index, 1, $len(self.preProps))
    // WARN: maybe multi result
    return self.preProps[index].getPropPositionAndScaleInWorldSpace()
}
StartPanel.prototype.setPrePropVisible = function (index, visible) {
    var self = this
    index = cc.clampf(index, 1, $len(self.preProps))
    self.preProps[index].setPropIconVisible(visible)
}
StartPanel.prototype.popup = function () {
    var self = this
    BasePanel.prototype.popup.call(self)
    self.tittleNode.setScale(0.3)
    self.tittleNode.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
        // ButtonPushBounceIdleBubbleAnim.create(self.comStarBtn)
    })))

    self.purpleAmyNode.setScale(0.3)
    self.purpleAmyNode.setOpacity(0)
    self.purpleAmyNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.1),
        cc.CallFunc.create(()=>{
            self.purpleAmyNode.setOpacity(255)
        }),
        cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
        // ButtonPushBounceIdleBubbleAnim.create(self.comStarBtn)
    })))

    self.selectNode.setScale(0.3)
    self.selectNode.setOpacity(0)
    self.selectNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.2),
        cc.CallFunc.create(()=>{
            self.selectNode.setOpacity(255)
        }),
        cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
        // ButtonPushBounceIdleBubbleAnim.create(self.comStarBtn)
    })))


    self.startBtn.setScale(0.3)
    self.startBtn.setOpacity(0)
    self.startBtn.runAction(cc.Sequence.create(cc.DelayTime.create(0.3),
        cc.CallFunc.create(()=>{
            self.startBtn.setOpacity(255)
        }),
        cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
        ButtonPushBounceIdleBubbleAnim.create(self.startBtn)
        if (self.useComplementStar){
            self.bubbleNode.setVisible(true)
        }
        self.dispatchEvent(table([1, "name", StartPanelEvent.FinishAnim]))
    })))

    if (self.adStartReward){
        self.btn_start_ad.setScale(0.3)
        self.btn_start_ad.setOpacity(0)
        self.btn_start_ad.runAction(cc.Sequence.create(cc.DelayTime.create(0.4),
            cc.CallFunc.create(()=>{
                self.btn_start_ad.setOpacity(255)
            }),
            cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
                ButtonPushBounceIdleBubbleAnim.create(self.btn_start_ad)
                self.start_ad_bubble.setVisible(true)
                if (TTUtil.isOpenSmallPay()){
                    self.ttUseDiamond = UserManager.getInstance().getTTSmallAmountUseDiamond()
                    self.tt_buuble = TTUtil.addSmallPayBubble(self.btn_start_ad,(ttUseDiamond)=>{
                        self.ttUseDiamond = ttUseDiamond
                    },{
                        "type" : "bef_stage_ad"
                    },{
                        fixPos: cc.p(0,30) 
                    })
                    self.start_ad_bubble.setPositionY(-80)
                }
        })))
        DCAssist.dc4User101("stage_start","getitems_ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
    }
    var animedBubble = table()
    for (var i = 1, v = self.preProps[1]; v; i++, v = self.preProps[i]) {
        table.insert(animedBubble, table([1, "obj", v], [1, "bubble", v.getBubble()]))
    }
 
    return self
    self.dispatchEvent(table([1, "name", StartPanelEvent.StartAnim]))
    var targetScale = self.getScale()
    var animedBubble = table()
    for (var i = 1, v = self.preProps[1]; v; i++, v = self.preProps[i]) {
        table.insert(animedBubble, table([1, "obj", v], [1, "bubble", v.getBubble()]))
    }
    //  播放面板进场动画
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var targetPos = cc.p(self.getPosition())
    var vSize = cc.Director.getInstance().getVisibleSize()
    self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
    var startPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 0.23)
    var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.16)
    self.setScale(0.23)
    self.setPosition(cc.p(self.getPositionX() + startPoint.x, self.getPositionY() + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(7 / 30, targetScale), cc.MoveTo.create(7 / 30, targetPos))), cc.CallFunc.create(function () {
        self.dispatchEvent(table([1, "name", StartPanelEvent.FinishAnim]))
        //  播放排行榜入场动画
        if (rank) {
            rank.setVisible(true)
            rank.runAction(cc.Sequence.create(cc.MoveTo.create(14 / 30, cc.p(rank.getPositionX(), rank.getPositionY() + 300)), cc.CallFunc.create(function () {
            })))
        }
    })))
    var bg2 = self.getChildByName("panel_sandbeach")
    var size = bg2.getContentSize()
    var tSize = cc.size(bg2.getPositionX() + size.width, -bg2.getPositionY() + size.height)
    var startPoint = cc.p(tSize.width / 12, -tSize.height / 12)
    var levelTarget = self.getChildByName("level_type")
    if (levelTarget) {
        levelTarget.setPosition(startPoint)
        var midPoint1 = cc.pMul(cc.p(-startPoint.x, -startPoint.y), 1.08)
        var midPoint2 = cc.pMul(cc.p(-startPoint.x, -startPoint.y), -0.05)
        levelTarget.runAction(cc.Sequence.create(cc.DelayTime.create(0.06), cc.EaseSineOut.create(cc.MoveBy.create(0.26, midPoint1)), cc.EaseSineIn.create(cc.MoveTo.create(0.16, midPoint2)), cc.MoveTo.create(0.1, cc.p(0, 0))))
    }
    if (self.useComplementStar){
        //  播放开始按钮动画
        self.comStarBtn.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
            ButtonPushBounceIdleBubbleAnim.create(self.comStarBtn)
        })))
    }
    //不能看广告开始，只显示一个按钮
    if (!self.adStartReward){
        //  播放开始按钮动画
        self.button.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
            ButtonPushBounceIdleBubbleAnim.create(self.button)
        })))
    }else{
        DCAssist.dc4User101("bef_stage_ad","ad_button_show",{session: AdStartPropManager.getInstance().createDCSession()})
        self.adStartBtn.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1), cc.CallFunc.create(function () {
            // ButtonPushBounceIdleBubbleAnim.create(self.adStartBtn)
            ButtonPushBounceAnim.create(self.adStartBtn)
            // var [scaleX, scaleY] = [self.adStartBtn.getScaleX(), self.adStartBtn.getScaleY()]
            // self.adStartBtn.runAction(cc.repeatForever(cc.sequence(cc.scaleTo(2, 1.05 * scaleX, 0.95 * scaleY), cc.scaleTo(2.0, scaleX, scaleY))))
            
        })))
        self.button.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.05)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.85)), cc.ScaleTo.create(0.13, 0.95), cc.CallFunc.create(function () {
            // ButtonPushBounceIdleBubbleAnim.create(self.button)
            ButtonPushBounceAnim.create(self.button)
            self.button.setScale(0.93)
            // self.button.setScaleY(0.9)
            // var [scaleX, scaleY] = [self.button.getScaleX(), self.button.getScaleY()]
            // self.button.runAction(cc.repeatForever(cc.sequence(cc.scaleTo(2, 1.05 * scaleX, 0.95 * scaleY), cc.scaleTo(2.0, scaleX, scaleY))))
        })))
    }

    //  播放气泡进场动画
    for (var i = 1, v = animedBubble[i]; v; i++, v = animedBubble[i]) {
        let copy_v = v;
        v.obj.stopAnim()
        v.bubble.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(7 / 30 + (i - 1) * 2 / 30, 1.2)), cc.EaseSineIn.create(cc.ScaleTo.create(6 / 30, 0.8)), cc.EaseSineOut.create(cc.ScaleTo.create(0.1, 1)), cc.CallFunc.create(function () {
            copy_v.obj.startAnim()
            if (i === $len(animedBubble)) {
                self.dispatchEvent(table([1, "name", StartPanelEvent.FinishAnim]))
            }
        })))
    }
    //  播放星星入场动画
    if (self.starAnimationList){
        for (var i = 1, v = self.starAnimationList[1]; v; i++, v = self.starAnimationList[i]) {
            var pos = cc.p(v.getPosition())
            var scaleValue = v.getScale()
            v.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(9 / 30, 1.2 * scaleValue), cc.MoveTo.create(9 / 30, cc.pAdd(self.starBasePos, cc.pMul(cc.pSub(pos, self.starBasePos), 1.05))))), cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(6 / 30, scaleValue), cc.MoveTo.create(6 / 30, pos)))))
        }
    }
    //  teachBook在原生中会在存在教学关的关前面板
    var teach_book = self.getChildByName("teach_book")
    if (teach_book) {
        teach_book.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.ScaleTo.create(0.3, 1.1)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, 0.9)), cc.ScaleTo.create(0.13, 1)))
    }
    return self
}
StartPanel.prototype.onKeyBackClicked = function () {
    var self = this
    self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
}
StartPanel.prototype.recordData = function () {
    var self = this
    self.fabNames = table(
        "button",
        "levelId",
        "levelIdL",
        "levelIdR",
        "shadow",
        "question",
        "bg2"
    )
    for (var i = 1; i <= 3; i += 1) {
        table.insert(self.fabNames, "lock" + i)
        table.insert(self.fabNames, "bubble" + i + "_tap")
        table.insert(self.fabNames, "bubble" + i)
        table.insert(self.fabNames, "bubble" + i + "_shadow")
        table.insert(self.fabNames, "bubbletab" + i + "_shadow")
        table.insert(self.fabNames, "bubbletabnum" + i)
        table.insert(self.fabNames, "bubbletabicon" + i)
        table.insert(self.fabNames, "numLabel" + i)
    }
    self.fabProps = table()
    for (var k in self.fabNames) {
        var v = self.fabNames[k]
        self.fabProps[v] = table()
        var child = self.getChildByName(v)
        if (child) {
            self.fabProps[v][1] = child.getPositionY()
            self.fabProps[v][2] = child.getOpacity()
        } else {
            self.fabProps[v][1] = 0
            self.fabProps[v][2] = 0
        }
    }
    self.bg2ContentSize = self.getChildByName("panel_sandbeach").getContentSize()
    self.targetNode = cc.Node.create()
    self.addChild(self.targetNode)
}
StartPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    var self = this 
    if ( this.actBanner){
        this.actBanner.onClose()
        this.actBanner = null
    }
    MarketManager.getInstance().setCashGoodsEntry(self.cachedMarketEntry);
    self.cachedMarketEntry = null;
    HomeSceneAnimation.setStarDrawInfoBanner(null);
    if (self.friendRank) {
        let rank = self.friendRank
        //  播放排行榜出场动画
        rank.runAction(cc.sequence(cc.moveBy(10 / 30, cc.p(0, - 300)), cc.callFunc(function () {
            rank.setVisible(false)
            if (global.mini && mini.supportOpenContext()) {
                OpenContextUtil.postMessage({
                    command: "exit"
                })
            }
            BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim)
        })))
    } else {
        BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim)
    }
}

StartPanel.prototype.showComplementStarAnim = function(propId){
    var self = this;
    cc.log("-----showComplementStarAnim-----", propId);
    var pos = HomeScene.getInstance().btnLayer.buttonBox.csNode.getPosition();
    pos = self.convertToNodeSpace(pos);
    pos = cc.pSub(pos, cc.p(60, 0));

    let bagButton = cc.Sprite.createWithSpriteFrameName("homeScene/backpack.png");
    cc.log(pos)
    bagButton.setPosition(pos);
    self.addChild(bagButton, 9999);

    var icon = UIItemBuilder.createPropIcon(propId);
    icon.setPosition(pos);
    self.addChild(icon, 9999);
    // var tarPos = self.startBtn.getPosition();
    var tarPos = self.startBtn.convertToWorldSpace(cc.p(self.energy_icon.getPosition()))

    tarPos = self.convertToNodeSpace(tarPos)
    tarPos.x -= 20
    tarPos.y -= 10

    let refreshNum = function(){
        // self.comStarBtn.getChildByName("power_1_activity").setVisible(true)
        self.startBtn.getChildByName("num").setColor(cc.c3b(255, 255, 255))
    }

    let actionList = new Array();
    actionList.push(cc.Spawn.create(cc.EaseSineInOut.create(he.HeBezierTo.create(15 / 30, cc.p(tarPos.x + 25, tarPos.y + 11 ), true, 100)), cc.ScaleTo.create(15 / 30, icon.getScale() * 0.65)))
    actionList.push(cc.callFunc(refreshNum));
    actionList.push(cc.DelayTime.create(7 / 30));
    actionList.push(cc.CallFunc.create(function () {
        self.dispatchEvent(table([1, "name", StartPanelEvent.UsePropAnimFinish]));
    }))
    icon.runAction(cc.Sequence.create(actionList))
}
StartPanel.prototype.showEnergyAnim = function(propId){
    var self = this;
    cc.log("-----showEnergyAnim-----", propId);
    self.useEnergyPropId = propId;

    var pos = HomeScene.getInstance().btnLayer.buttonBox.csNode.getPosition();
    pos = self.convertToNodeSpace(pos);
    pos = cc.pSub(pos, cc.p(60, 0));

    let bagButton = cc.Sprite.createWithSpriteFrameName("homeScene/backpack.png");
    cc.log(pos)
    bagButton.setPosition(pos);
    self.addChild(bagButton, 9999);

    var icon = UIItemBuilder.createPropIcon(propId);
    icon.setPosition(pos);
    icon.setAnchorPoint(cc.p(0.5, 0.5))
    self.addChild(icon, 9999);
    // var scene = cc.Director.getInstance().getRunningScene()
    // scene.addChild(icon, 1000)
    // var tarPos = self.startBtn.getPosition();
    var tarPos = self.startBtn.convertToWorldSpace(cc.p(self.energy_icon.getPosition()))

    tarPos = self.convertToNodeSpace(tarPos)
    if (propId== GamePropsType.kEnergy1){
        tarPos.x -= 20
        tarPos.y -= 12
    }else if (propId== GamePropsType.kEnergy2){
        tarPos.x -= 15
        tarPos.y -= 10
    }
   

    cc.log("tarPos", tarPos)

    var refreshNum = function(){
        if (self.useEnergyPropId == GamePropsType.kEnergy1){
            // self.button.getChildByName("num5").setVisible(false);
            // self.button.getChildByName("num5_activity").setVisible(true);
        }else{
            // self.button.getChildByName("num1").setVisible(false);
            // self.button.getChildByName("num1_activity").setVisible(true);
        }
        self.startBtn.getChildByName("num").setColor(cc.c3b(255, 255, 255))

    }

    
    let actionList = new Array();
    actionList.push(cc.Spawn.create(cc.EaseSineInOut.create(he.HeBezierTo.create(15 / 30, cc.p(tarPos.x + 25, tarPos.y + 11 ), true, 100)), cc.ScaleTo.create(15 / 30, icon.getScale() * 0.65)))
    actionList.push(cc.callFunc(refreshNum));
    actionList.push(cc.DelayTime.create(7 / 30));
    actionList.push(cc.CallFunc.create(function () {
        self.dispatchEvent(table([1, "name", StartPanelEvent.UsePropAnimFinish]));
    }))
    icon.runAction(cc.Sequence.create(actionList))

    // self.dispatchEvent(table([1, "name", StartPanelEvent.UsePropAnimFinish]));
}

StartPanel.prototype.initStrategy = function() {
    let self = this;
    let strategy = self.getChildByName("gonglve_team");
    let strategyBtn = strategy.getChildByName("btn_gonglve");
    strategy.setVisible(false);
    quickBuildUIButton(strategyBtn,() =>{
        if(self.strategyId) {
            self.dispatchEvent(
                {
                    "name": StartPanelEvent.PlayStrategy, 
                    "strategyId": self.strategyId,
                    "strategyContent": self.strategyContent,
                    "isNewStrategy": self.isNewStrategy,
                }
            );
        }
    })
    //以下三个条件和FailMainLevelLogic的loadPanelSuccess保持一致
    let snsProxy = require("clover/sns/SnsProxy").getInstance();
    if(self.levelId > 10000 || !snsProxy.allowAd()) {
        return;
    }
    if([2206, 2207, 2210, 2213, 2214, 2216, 2218, 2225, 2226, 2228, 2229, 2233, 2235, 2236, 2237, 2240, 2243, 2248, 2250, 2251, 2256, 2258, 2267, 2274, 2280, 2286, 2288, 2293, 2296, 2299, 2313, 2316, 2317, 2326, 2333, 2346, 2358, 2367, 2385, 2396, 2435, 2438, 2450, 2494, 2545, 2568, 2595, 2627, 2712].includes(self.levelId)){
        return;
    }
    if(LevelConfigManager.getInstance().isLevelB(self.levelId)) {
        return;
    }
    // iaa不要高手攻略
    if (UserManager.getInstance().isUseIAA()){
        return
    }

    var checkCanShowStrategy = function(data){
        var config = CfgManager.get("game");
        var failNum = data.failNum;
        
         //失败次数满了显示有攻略的失败界面，否则还是老的失败
        if (failNum >= config["level_tip_show_limit"] && data.strategyId != ""){
            self.strategyId = data.strategyId;
            self.strategyContent = data.content;
            self.isNewStrategy = data.isNewStrategy;
            strategy.setVisible(true);
            snsProxy.prepareAd("Startegy");

            DCAssist.dc4User101("levelTip","ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
        }
    }

    var success = function(evt){
        CfgManager.load("game").then((dataMap)=>{
            checkCanShowStrategy(evt.data);
            CfgManager.release("game");
        }).catch((err) => {
            console.error("load game config failed!", err);
        });  
    }

    var fail = function(errorCode){

    }
    
    var http = GetUserStrategyInfoHttp.new();
    http.addEventListener(Events.kComplete, success);
    http.addEventListener(Events.kError, fail);
    http.addEventListener(Events.kCancel, fail);
    http.load(UserManager.getInstance().uid, null, this.levelId);
}

//勋章功能
StartPanel.prototype.buildMedalRank = function(data) {
    let self = this;
    let MedalRankSign = require("../scene/component/homescene/NewRank/MedalRankSign");
    self.medalRankData = {
        count: data.levelMedal,
        rank: data.levelScoreRank || 9999,
        timestamp: data.levelScoreRankTime,
        levelId: self.levelId,
    };
    let sign = MedalRankSign.create(self.medalRankData, self);
    self.addChild(sign);
    sign.y = 220;
}
//关前面板曝光时
StartPanel.prototype.dcPageShow = function(pf) {
    let self = this;
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    let num = -1;
    let record = -1;
    if(self.medalRankData) {
        num = self.medalRankData.count;
        record = self.medalRankData.rank;
    } else {
        let hasStar = self.scoreConfig.star;
        if(hasStar) {
            num = 0;
            record = 0;
        }
    }

    let params = {
        session,
        current_stage: self.levelId,
        pf,
        record,
        num,
    }
    self.params = params;
    MedalRankManager.getInstance().dcSimple("stage_start_page_show", params);
}

StartPanel.prototype.removeFromParent = function(cleanup) {
    let self = this;
    if ( this.actBanner){
        this.actBanner.onClose()
        this.actBanner = null
    }
    cc.Node.prototype.removeFromParent.call(self, cleanup);
    // 开始窗在精力不足时会被popouManager.removeall，无法触发onclose，因此在这里还原打点进入场景
    if(!self.isClosed) {        
        MarketManager.getInstance().setCashGoodsEntry(self.cachedMarketEntry);
        self.cachedMarketEntry = null;
    }
}
/**
 * UI适配屏幕分辨率
 */
StartPanel.prototype.fitScreen = function () {
    var self = this
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width
    var scale = Math.min(scaleX, scaleY)
    cc.log("fitScreen", scale)
    self._scale = scale
    self.setScale(self._scale)
}

module.exports = table([0, StartPanel], [0, StartPanelEvent])
